import 'modules/intro-headline/intro-headline';
import 'modules/case-study-link/case-study-link';
import 'modules/swipe-carousel/swipe-carousel';
import { style } from 'spark-helpers';
import './index.scss';

const caseTextContainers = document.querySelectorAll('.case-study-link__case-text-container');

style.evenHeights(caseTextContainers);
